import styled, { css } from 'styled-components';
import { mediaQueries } from '@fourthwall/components';
export const Container = styled.div `
  display: flex;

  gap: 10px;
  align-items: center;

  padding: 12px var(--space-500);

  font-size: var(--font-size-300);
  font-weight: var(--font-weight-medium);
  line-height: var(--font-line-height-300);
  letter-spacing: var(--font-letter-spacing-loose);

  ${mediaQueries.tablet} {
    gap: 16px;
  }

  &:not(:last-child) {
    border-bottom: 1px solid var(--border-secondary);
  }

  ${({ completed }) => !completed &&
    css `
      &:hover {
        background: var(--bg-primary-hover);
      }
    `}

  ${({ completed }) => completed &&
    css `
      color: var(--text-secondary);
    `}
`;
export const Icon = styled.span `
  font-size: var(--font-size-400);
`;
export const Title = styled.div `
  font-size: var(--font-size-300);

  ${mediaQueries.tablet} {
    font-size: var(--font-size-400);
  }
`;
export const Award = styled.div `
  border-radius: var(--radius-brand);
  padding: 2px var(--space-200);
  background: var(--bg-success);
  color: var(--text-primary-invert);
`;
export const ButtonContainer = styled.div `
  margin-left: auto;
`;
export const Completed = styled.div `
  display: flex;

  align-items: center;
  gap: var(--space-250, 10px);

  font-size: var(--font-size-300);
  line-height: var(--font-line-height-300);
  letter-spacing: var(--font-letter-spacing-loose);
`;
